import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import {
  foundingMemberCreatorPath,
  foundingMemberCreatorPausePath,
  foundingMemberCreatorStagePath,
} from "@travily/routes";
import type FoundingMemberCreatorFamilyHubs from "@travily/types/pages/FoundingMemberCreatorFamilyHubs";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { FoundingMemberFamilyHubsStepView } from "./show.view";

type FormData = {
  family_profile: {
    hubs_experience: string | null;
    hubs_visited: string;
  };
};

const EXPERIENCE_FIELD = "family_profile.hubs_experience";
const VISITED_FIELD = "family_profile.hubs_visited";

const HubsStep = ({ stage_index, stage_order, family_profile }: FoundingMemberCreatorFamilyHubs) => {
  const { form, validate, fieldError, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } =
    useWizardForm<FormData>({
      routes: {
        stageUrl: (stage) => foundingMemberCreatorStagePath("family", stage),
        entryUrl: foundingMemberCreatorPath(),
        pauseUrl: foundingMemberCreatorPausePath(),
      },
      stageName: "hubs",
      stageIndex: stage_index,
      stageOrder: stage_order,
      initialData: {
        family_profile: {
          hubs_experience: family_profile.hubs_experience ?? null,
          hubs_visited: family_profile.hubs_visited ?? "",
        },
      },
    });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.founding_members.creator.steps.family.hubs.show.meta_title")}>
        <meta name="description" content={t("web.founding_members.creator.steps.family.hubs.show.meta_description")} />
      </Head>
      <FoundingMemberFamilyHubsStepView
        experienceValue={form.data.family_profile.hubs_experience}
        visitedValue={form.data.family_profile.hubs_visited}
        error={fieldError(EXPERIENCE_FIELD)}
        currentStage={currentStage}
        totalStages={totalStages}
        primaryPending={primaryPending}
        topBarActions={topBarActions}
        onBack={onBack}
        onPrimary={onPrimary}
        onExperienceChange={(value) => {
          form.setData(EXPERIENCE_FIELD, value);
          validate(EXPERIENCE_FIELD);
        }}
        onVisitedChange={(value) => form.setData(VISITED_FIELD, value)}
      />
    </>
  );
};

export default HubsStep;
